export default __webpack_public_path__ + "static/status-71382597aacc723e22f94afb79ba569a.gif";